import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ClipboardText, CalendarCheck, ChatCircle, FileText } from '@phosphor-icons/react';
import axiosInstance, { schedulingAPI } from '../../api/api';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const todayISO = () => new Date().toISOString().slice(0, 10);

export const WorkerTodayStrip = ({ pendingApplications = 0 }) => {
  const navigate = useNavigate();
  const [tasksToday, setTasksToday] = useState(0);
  const [phasesToday, setPhasesToday] = useState(0);
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    axiosInstance.get(`/daily-checklists?date=${todayISO()}`)
      .then(({ data }) => setTasksToday((data?.checklists || []).length)).catch(() => {});
    schedulingAPI.list().then(({ data }) => {
      const t = todayISO();
      setPhasesToday((data?.schedules || []).reduce(
        (n, s) => n + (s.phases || []).filter((p) => p.start_date <= t && t <= p.end_date).length, 0));
    }).catch(() => {});
    const token = localStorage.getItem('token');
    fetch(`${API_URL}/api/messages/unread/count`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.json()).then((d) => setUnread(d?.unread_count || 0)).catch(() => {});
  }, []);

  const scrollTo = (testid) => document.querySelector(`[data-testid="${testid}"]`)?.scrollIntoView({ behavior: 'smooth' });

  const cards = [
    { label: 'Tasks Today', value: tasksToday, icon: ClipboardText, color: '#059669', onClick: () => scrollTo('worker-today-checklists'), testId: 'today-tasks' },
    { label: 'On Schedule Today', value: phasesToday, icon: CalendarCheck, color: '#EA580C', onClick: () => scrollTo('worker-schedule-card'), testId: 'today-schedule' },
    { label: 'Unread Messages', value: unread, icon: ChatCircle, color: '#7C3AED', onClick: () => navigate('/messages'), testId: 'today-messages' },
    { label: 'Pending Applications', value: pendingApplications, icon: FileText, color: '#2563EB', onClick: () => navigate('/my-applications'), testId: 'today-applications' },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6" data-testid="worker-today-strip">
      {cards.map(({ label, value, icon: Icon, color, onClick, testId }) => (
        <button
          key={testId}
          onClick={onClick}
          className={`text-left bg-white dark:bg-neutral-800 border-2 rounded-xl p-3.5 shadow-[3px_3px_0px_#0F172A] dark:shadow-[3px_3px_0px_#2563EB] hover:-translate-y-0.5 active:translate-y-0 transition-all ${value > 0 ? 'border-[#0F172A] dark:border-neutral-600' : 'border-neutral-200 dark:border-neutral-700 opacity-70'}`}
          data-testid={testId}
        >
          <div className="flex items-center justify-between">
            <Icon size={20} weight="bold" style={{ color }} />
            <span className="text-2xl font-black text-neutral-900 dark:text-white">{value}</span>
          </div>
          <p className="text-[11px] font-bold uppercase tracking-wide text-neutral-500 dark:text-neutral-400 mt-1">{label}</p>
        </button>
      ))}
    </div>
  );
};

export default WorkerTodayStrip;
